import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useField } from 'react-final-form';
import React, { Fragment } from 'react';
export const CheckboxField = ({ name, label, validate }) => {
    const { input } = useField(name, { validate: validate });
    const handleChange = (event, checked) => {
        input.onChange(checked);
    };
    return (React.createElement(Fragment, null,
        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: !!input.value, edge: "start", onChange: handleChange, inputProps: {
                    'aria-label': input.name,
                } }), label: label })));
};
//# sourceMappingURL=CheckboxField.js.map